import { Box, Button } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SaveIcon from "@mui/icons-material/Save";
import { FormValues, Step } from "./Onboarding";
import { useFormikContext } from "formik";
import { AxiosResponse } from "axios";

interface ActionButtonsProps {
  csvFile: any;
  activeStep: Step;
  updateResult?: AxiosResponse;
  isLoading: boolean;
  handleBack: () => void;
  handleNext: () => void;
  serverValidate: () => void;
  handleImport: () => void;
  setShowConfirmation: (value: boolean) => void;
}

const classes = {
  root: {
    position: "sticky",
    bottom: 0,
    right: 0,
    padding: "10px",
    width: "100%",
    background: "#fafafa",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderTop: "1px solid #efefef",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  iconSize: {
    fontSize: "14px!important",
  },
};

const ActionButtons = (props: ActionButtonsProps) => {
  const {
    activeStep,
    updateResult,
    isLoading,
    handleBack,
    handleNext,
    setShowConfirmation,
    serverValidate,
    csvFile,
    handleImport
  } = props;

  const history = useHistory();

  const renderBtn = (activeStep: Step) => {
    switch (activeStep) {
      case Step.Uploading:
        return (
          <Box sx={classes.btnWrapper}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
              onClick={() =>
                history.goBack()
              }
            >
              Exit
            </Button>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ArrowForwardIosIcon sx={classes.iconSize} />}
              onClick={serverValidate}
              disabled={!csvFile || isLoading}
            >
              Next
            </Button>
          </Box>
        );
      case Step.Mapping:
        return (
          <Box sx={classes.btnWrapper}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleImport}
              disabled={isLoading}
            >
              Next
            </Button>
          </Box>
        );
      // case Step.ErrorChecking:
      //   return (
      //     <Box sx={classes.btnWrapper}>
      //       <Button
      //         variant="outlined"
      //         color="primary"
      //         startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
      //         onClick={handleBack}
      //       >
      //         Back
      //       </Button>
      //       {isLoading ? null : (
      //         <Button
      //           variant="contained"
      //           color="primary"
      //           endIcon={<ArrowForwardIosIcon sx={classes.iconSize} />}
      //           onClick={serverValidate}
      //         >
      //           Next
      //         </Button>
      //       )}
      //     </Box>
      //   );
      case Step.ServerErrorChecking:
        return (
          <Box sx={classes.btnWrapper}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ArrowForwardIosIcon sx={classes.iconSize} />}
              onClick={() => handleNext()}
              disabled={isLoading}
            >
              Next
            </Button>
          </Box>
        );
      case Step.Result:
        return (
          <Box display="flex" justifyContent="end" alignItems="center">
            {isLoading ? null : (
              <>
                {updateResult?.status === 200 ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
                    onClick={() => history.goBack()}
                  >
                    Exit
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                )}
              </>
            )}
          </Box>
        );
      default:
        return (
          <Button
            onClick={() => setShowConfirmation(true)}
            startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
          >
            Exit
          </Button>
        );
    }
  };

  return (
    <Box display="flex" justifyContent="space-between" sx={classes.root}>
      {renderBtn(activeStep)}
    </Box>
  );
};

export default ActionButtons;
